import { Page } from "$components/page";
import { useQuerystring } from "$routes/_lib/use-querystring";
import { DateRangePicker } from "$routes/inventory/_lib/date-range-picker";
import InventoryTitleRow from "$routes/inventory/_lib/inventory-title-row";
import { LocationSelectWithAllOption } from "$routes/inventory/_lib/location-select-with-all-option";
import { useUpdateQueryParamCallback } from "$routes/inventory/_lib/use-update-query-param-callback";
import { linkToInventory, linkToInventoryAudit } from "$routes/inventory/links";
import { Box, Grid } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import InventoryAuditTable from "./_lib/inventory-audit-table";

const InventoryAudit: FC = () => {
  const queryParams = useQuerystring();

  const { locationId, startDate = null, endDate = null } = queryParams;

  const makeUpdateQueryParam = useUpdateQueryParamCallback({
    analyticsNamespace: "inventory.audit",
    linkFactory: linkToInventoryAudit,
  });

  const setLocationId = makeUpdateQueryParam("locationId");
  const setStartDate = makeUpdateQueryParam("startDate");
  const setEndDate = makeUpdateQueryParam("endDate");

  return (
    <Page data-dense>
      <InventoryTitleRow
        backToLink={linkToInventory()}
        title={
          <FormattedMessage
            id="inventory.audit.title"
            defaultMessage="Inventory Audit"
          />
        }
      >
        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs={12} sm={6}>
            <LocationSelectWithAllOption
              value={locationId}
              onChange={setLocationId}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <DateRangePicker
                hideHelper
                clearable
                fromValue={startDate}
                setFromValue={setStartDate}
                toValue={endDate}
                setToValue={setEndDate}
              />
            </Box>
          </Grid>
        </Grid>
      </InventoryTitleRow>
      <Box marginTop={4}>
        <InventoryAuditTable
          startDate={startDate}
          endDate={endDate}
          locationId={locationId}
        />
      </Box>
    </Page>
  );
};

export default InventoryAudit;
